import React from "react";

import { ReactSVG } from "react-svg";
import { Typography } from "@components/Typography";
import { ModalProps } from "@/contexts/ModalContext/types";
import { QREditorModalDataProps } from "@/templates/QrEditorTemplates/qr-layout/types";
import "./styles.scss";

export const getUnlockFeaturesModal = (props: ModalProps<QREditorModalDataProps>) => {
  const { data, onConfirmButton } = props;
  return (
    <React.Fragment>
      <ReactSVG
        className="u-spacing-6"
        data-testid="confirm-img"
        src={data.image}
      />
      <div className="modal-text">
        {data.richtext.map((item, i) => {
          return (
            <Typography
              key={i}
              {...item}
            >
              {item.content}
            </Typography>
          );
        })}
      </div>
      <span
        className="button primary-color semi-bold"
        onClick={onConfirmButton}
        style={{ width: "100%" }}
      >
        {data.button.label}
      </span>
    </React.Fragment>
  );
};
